import { api } from '@/lib/api/client';
import type {
  WhatsAppGatewayResponse, WhatsAppSettingsInput, WhatsAppTestConnectionResult,
  WhatsAppTemplate, WhatsAppTemplateInput, WhatsAppValues, WhatsAppPreview, WhatsAppTestSendResult,
  DeliveryLogRow, DeliveryLogFilters,
} from './types';
import type { AutomaticEvent } from '../sms-gateway/types';

const BASE = '/admin/whatsapp-gateway';

/** GET /settings — the WhatsApp side of the MSG91 account and its readiness verdict. */
export const fetchGateway = () => api.get<WhatsAppGatewayResponse>(`${BASE}/settings`);

export const saveGateway = (data: WhatsAppSettingsInput) =>
  api.patch<WhatsAppGatewayResponse>(`${BASE}/settings`, data);

/** Save & test: saves first, then lists the templates MSG91 holds for the integrated number. */
export const testConnection = (data: WhatsAppSettingsInput) =>
  api.post<WhatsAppTestConnectionResult>(`${BASE}/settings/test`, data);

export const fetchTemplates = () => api.get<WhatsAppTemplate[]>(`${BASE}/templates`);

export const createTemplate = (data: WhatsAppTemplateInput) =>
  api.post<WhatsAppTemplate>(`${BASE}/templates`, data);

export const updateTemplate = (id: number, data: WhatsAppTemplateInput) =>
  api.patch<WhatsAppTemplate>(`${BASE}/templates/${id}`, data);

/** Built from the STORED components — save first to preview an edit server-side. */
export const previewTemplate = (templateId: number, values: WhatsAppValues) =>
  api.post<WhatsAppPreview>(`${BASE}/preview`, { template_id: templateId, values });

/** To a staff number. Same path as a real send, minus the patient consent gate. */
export const testSend = (templateId: number, mobile: string, values: WhatsAppValues) =>
  api.post<WhatsAppTestSendResult>(`${BASE}/test-send`, { template_id: templateId, mobile, values });

/** The same list as the SMS router's /events, for a WhatsApp-only admin. */
export const fetchEvents = () => api.get<AutomaticEvent[]>(`${BASE}/events`);

export const fetchDeliveryLog = (filters: DeliveryLogFilters) =>
  api.get<DeliveryLogRow[]>(`${BASE}/log`, { query: filters });
